import Cookies from "js-cookie"

export const getToken = () => {
  return Cookies.get('trauth')
}

export const setToken = (token: string) => {
  Cookies.set('trauth', token)
}

export const clearToken = () => {
  Cookies.remove('trauth')
}
